// 接口地址
const ROOT_PATH = `${window.location.origin}`;
// const WS_ROOT_PATH = ROOT_PATH.replace('http', 'ws');
// 是否是https
// const IS_HTTPS = /https/.test(`${window.location.protocol}`);
// 全局配置
const config = {
  apiPath: {
    // service: 'https://yyb.zhenai1000.cn/admin', // 回归
    service: `https://yyb.yiyujiehe.com/admin` // 线上
    // service: `http://192.168.2.66:1001` // 测试
  }
};

// 开发环境下mock地址
if (process.env.NODE_ENV === "development") {
  config.apiPath.service = `${ROOT_PATH}/api`;
}

// 集成发布模式下config配置不写入window全局下
if (process.env.NODE_ENV !== "publish") {
  (function (window) {
    //eslint-disable-line
    window.config = {
      globalConfig: {
        apiPath: config.apiPath
      }
    };
  })(window);
}

export default config;



// WEBPACK FOOTER //
// ./src/utils/config.utils.js